//model-meta generated file
import {DateTime,ModelMeta,uuid} from '../../lib/model-meta';
import {WhereTable,RestTypes as _RestTypes} from '../../lib/model-meta';

export class MonthlyFragmentationReport{
	public id:number;
	public clientId:number;
	public siteId:number=0;
	public deviceId:number;
	public month:string;
	public begin:number;
	public end:number;
	public status:string="generating";
	public settingsHash:string="";
	public reportData:string="";
	public generatedAt:DateTime|null=null;
	public createdAt:DateTime=new DateTime();
	public updatedAt:DateTime=new DateTime();
}

export namespace MonthlyFragmentationReport{
	export const meta=new ModelMeta<keyof Props>(
		"MonthlyFragmentationReport",
		[],
		[
			{
				name: "id",
				type: "serial",
				decorators: {},
				uniqueKey: true,
				notNull: true
			},{
				name: "clientId",
				type: "int",
				decorators: {},
				notNull: true
			},{
				name: "siteId",
				type: "int",
				decorators: {},
				default: 0,
				optional: true,
				notNull: true
			},{
				name: "deviceId",
				type: "int",
				decorators: {},
				notNull: true
			},{
				name: "month",
				type: "string",
				decorators: {},
				notNull: true,
				comment: "Format: \"2026-07\""
			},{
				name: "begin",
				type: "int",
				decorators: {},
				notNull: true,
				comment: "Month range stored as epoch seconds."
			},{
				name: "end",
				type: "int",
				decorators: {},
				notNull: true
			},{
				name: "status",
				type: "string",
				decorators: {},
				default: "generating",
				optional: true,
				notNull: true
			},{
				name: "settingsHash",
				type: "string",
				decorators: {},
				default: "",
				optional: true,
				notNull: true
			},{
				name: "reportData",
				type: "string",
				decorators: {},
				default: "",
				optional: true,
				notNull: true,
				comment: "processed monthly report data"
			},{
				name: "generatedAt",
				type: "date",
				decorators: {
					"rest.readonly": true
				},
				default: null,
				optional: true
			},{
				name: "createdAt",
				type: "date",
				decorators: {
					"rest.readonly": true
				},
				default: "now()",
				optional: true,
				notNull: true
			},{
				name: "updatedAt",
				type: "date",
				decorators: {},
				default: "now()",
				optional: true,
				notNull: true
			}
		]
	);

	interface Props{
		id:number;
		clientId:number;
		siteId?:number;
		deviceId:number;
		month:string;
		begin:number;
		end:number;
		status?:string;
		settingsHash?:string;
		reportData?:string;
		generatedAt?:DateTime|null;
		createdAt?:DateTime;
		updatedAt?:DateTime;
	}


	meta.generateRest("monthly-fragmentation-report",[
		{
			name: "email",
			type: "string",
			decorators: {}
		},{
			name: "authToken",
			type: "string",
			decorators: {}
		}
	]);

	export interface ReadableProps{
		id:number;
		clientId:number;
		siteId?:number;
		deviceId:number;
		month:string;
		begin:number;
		end:number;
		status?:string;
		settingsHash?:string;
		reportData?:string;
		generatedAt?:DateTime|null;
		createdAt?:DateTime;
		updatedAt?:DateTime;
	}

	export interface ReadablePrimitiveProps{
		id:number;
		clientId:number;
		siteId?:number;
		deviceId:number;
		month:string;
		begin:number;
		end:number;
		status?:string;
		settingsHash?:string;
		reportData?:string;
		generatedAt?:DateTime|null;
		createdAt?:DateTime;
		updatedAt?:DateTime;
	}

	namespace body{

		interface WritableProps{
			clientId:number;
			siteId?:number;
			deviceId:number;
			month:string;
			begin:number;
			end:number;
			status?:string;
			settingsHash?:string;
			reportData?:string;
			updatedAt?:DateTime;
		}

		export interface Auth{
			email?:string;
			authToken?:string;
		}

		export interface Get extends Auth{
			where:number;
			fields?:(keyof ReadableProps)[];
		}

		export interface Put extends Auth{
			where:number;
			fields:Partial<WritableProps>;
		}

		export interface Post extends Auth{
			fields:Partial<WritableProps>;
		}

		export interface Delete extends Auth{
			where:number;
		}

		export interface Count extends Auth{
			where?:WhereTable<keyof ReadablePrimitiveProps>;
		}

		export interface Search extends Auth{
			fields?:(keyof ReadablePrimitiveProps)[];
			where?:WhereTable<keyof ReadablePrimitiveProps>;
			range?:[number,number];
			sort?:Partial<Record<keyof ReadablePrimitiveProps,'+'|'-'>>;
		}
	}

	namespace _response{
		export type Get=Partial<ReadableProps>;
		export type Search=Partial<ReadablePrimitiveProps>[];
	}

	export interface RestTypes extends _RestTypes{
		body:{
			Auth:body.Auth;
			Get:body.Get;
			Put:body.Put;
			Post:body.Post;
			Delete:body.Delete;
			Count:body.Count;
			Search:body.Search;
		}

		response: {
			Get:_response.Get;
			Search:_response.Search;
		}
	}

}
